module.exports = __webpack_public_path__ + "img/Quantum Disputes.090c466f.png";